import { useQuery } from '@tanstack/react-query';
import { getHomeDashboard } from '../lib/home';
import type { HomeDashboardResponse } from '../types';

export const homeKeys = {
  all: ['home'] as const,
  dashboard: () => [...homeKeys.all, 'dashboard'] as const,
};

export function useHomeDashboard(enabled: boolean = true) {
  return useQuery<HomeDashboardResponse>({
    queryKey: homeKeys.dashboard(),
    queryFn: getHomeDashboard,
    staleTime: 60 * 1000,
    retry: false,
    enabled,
  });
}
